import { db } from '../../constants/firebaseModular';
import { doc, updateDoc } from 'firebase/firestore';

export type UpdateConciergeNavigatorFieldPayload = {
  patientId: string;
  field: 'telehealthShowAlert' | 'telehealthCallActive' | 'telehealthCallURL';
  value: boolean | string;
};

export const updateConciergeNavigatorField = async (payload: UpdateConciergeNavigatorFieldPayload) => {
  const docRef = doc(db, 'users', payload.patientId);
  const fieldString = `conciergeNavigator.${payload.field}`;
  await updateDoc(docRef, {
    [fieldString]: payload.value,
  });
};
